import React, { useState, useEffect, useRef } from 'react';
import { Checkbox } from "primereact/checkbox";
import { Button, CheckboxField } from "../../helpers";
import { Table } from "../../helpers"
import { Link } from "react-router-dom";
import moment from "moment"

import { Menu } from 'primereact/menu';
import { Toast } from 'primereact/toast';
import { Sidebar } from 'primereact/sidebar';
import { Tooltip } from "primereact/tooltip";

import ButtonGroup from '../../common/ButtonGroup';

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import UnreadMessageImg from '../../images/unread-message.webp'
import { searchTickets } from '../../services/api/tickets';
import { fetchTicketList, updateSearchParams, setInitialLoad, setIsSearchVisible} from "../../services/redux/reducers/tickets/tickets";
import { TicketSearch } from './components/TicketSearch'

import { DATE_TIME_FORMAT, DATE_FORMAT } from '../../constants'
import useTranslationWithLoading from '../../common/hooks/useTranslationWIthLoading';
import { isMobile } from '../../utils';

import SmartFilterActiveImg from "../../images/smartFilterActiveImg_.png"

export const TicketList = () => {
    const navigate = useNavigate()

    let ticketList = useSelector(state => state.ticketsData.ticketList)
    const userId = useSelector(state => state.userDetails).userId
    const isLoading = useSelector(state => state.ticketsData.loading)
    const paginationParams = useSelector(state => state.ticketsData.paginationParams)
    const searchParams = useSelector(state => state.ticketsData?.searchParams)
    const isInitialLoad = useSelector(state => state.ticketsData.isInitialLoad)
    const isSearchVisible = useSelector(state => state.ticketsData.isSearchVisible)
    const isSearchActive = useSelector(state => state.ticketsData.isSearchActive)

    const activeUserRoleDetails = useSelector((state) => state.userDetails?.activeUserRoleDetails)
    const PMCompanyDetails = useSelector((state) => state.userDetails.PMCompanyDetails)

    const actionMenu = useRef(null)

    const isMobileDevice = isMobile()

    const dispatch = useDispatch()

    useEffect(() => {
        getIntialLoadData()
    }, [])

    const getIntialLoadData = () => {
        if(isInitialLoad){
            dispatch(setInitialLoad(false))

            const assignToMe = true
            const openStatus = true

            const currentDate = new Date()
            let fromDate  = currentDate.setMonth(currentDate.getMonth() -  1)
            fromDate = new Date(fromDate)
            let toDate = new Date()
            const procmartUser = activeUserRoleDetails?.companyId === PMCompanyDetails.companyId

            const updatedSearchParams = {
                ...searchParams,
                fromDate,
                toDate,
                assignToMe,
                openStatus,
                procmartUser,
                smartSearch: true
            }

            dispatch(updateSearchParams(updatedSearchParams))
            dispatch(fetchTicketList({
                ...paginationParams,
                ...updatedSearchParams,
                userId
            }))
        }
    }

    const getDueDate = (row) => {

        if(row.dueDate){

            const todayDate =  moment(new Date())
            let dueDate = moment(new Date(row.dueDate))
            const dateDiff = dueDate.diff(todayDate, 'days')

            let textColor = ''
            if(dateDiff == 0){
                let duration = moment.duration(dueDate.diff(todayDate))
                let hoursDiffrence = duration.asHours()

                if(hoursDiffrence > 0){
                    textColor = '#45a6ad' //lightgreen
                } else {
                    textColor = 'rgb(160, 160, 63)' //yellow
                }
            }
            if(dateDiff){
                if(dateDiff < 0){
                    textColor = '#cf2634' //red
                }
                if(dateDiff > 0 && dateDiff < 3){
                    textColor = '#45a6ad' //lightgreen
                }
                if(dateDiff >= 3){
                    textColor = '#045050' //darkgreen
                }
            }

            return <div><span style={{ color : textColor, fontWeight : 'bold' }} > {moment(new Date(row?.dueDate)).format(DATE_FORMAT)}</span></div>
        }
        else {
            return <div> - </div>
        }

    }

    const getLastViewedTime = (ticketId) => {
        return localStorage.getItem(`ticket_${ticketId}_last_viewed`)
    }

    const setLastViewedTime = (ticketId) => {
        localStorage.setItem(`ticket_${ticketId}_last_viewed`, new Date().toISOString())
        window.dispatchEvent(new Event('storage'))
    }

    const getTicketTitle = (rowData) => {
        let lastViewedTime = null
        if (rowData && rowData.ticketId){
            lastViewedTime = getLastViewedTime(rowData.ticketId)
        }
        const isNewActivity = !lastViewedTime || new Date(rowData.updatedAt) > new Date(lastViewedTime)

        return (
            <div>
                <Link to={`./edit/${rowData.ticketId}`}
                    style={{ color: isNewActivity ? "black" : "#3366cc" }}
                    onClick={() => setLastViewedTime(rowData.ticketId)}>
                    <p className='m-0'>
                        {rowData.title}
                        {isNewActivity && <img className={`ml-1 custom-tooltip-${rowData.ticketId}`} src={UnreadMessageImg} style={{ height: 12 }} />} {/* Add a marker for new activity */}
                    </p>
                    <Tooltip target={`.custom-tooltip-${rowData.ticketId}`} position="top" autoHide>
                        Unread comments
                    </Tooltip>
                </Link>
            </div>
        )
    }

    const getPriority = (row) =>{
        let priority = row.priority
        let priorityColor = ''
        switch (priority) {
            case 'URGENT':
                priorityColor = '#ff00008c'
                break
            case 'HIGH':
                priorityColor = '#ffa500b0'
                break
            case 'MEDIUM':
                priorityColor = '#0000ff6e'
                break
            case 'LOW':
                priorityColor = '#00800099'
                break
            default:
                priorityColor = 'black'
        }

        return(
            <div className='ticket-priority' style={{ backgroundColor : priorityColor }}>{row.priority}</div>
        )
    }

    const handleSmartFilter = async () => {
        let updatedSerachParams = {
            ...paginationParams,
            ...searchParams,
            userId,
            smartSearch: true,
        }
        dispatch(fetchTicketList(updatedSerachParams))
        dispatch(updateSearchParams({ ...searchParams, smartSearch: true }))
    }

    const smartFilterBody = () => {
        return (
            <img src={SmartFilterActiveImg} style={{ width: "25px", cursor: 'pointer', backgroundImage: 'radial-gradient(circle at top left, #cad4ff 2%, #ffffff00)' }} onClick={() => handleSmartFilter()} />
        )
    }

    const tableColumns = [
        {
            header: smartFilterBody,
            body: "",
            style: { minWidth: "5px" }
        },
        {
            header : 'Ticket Id',
            field : 'ticketId',
            style: { minWidth: "120px"}
        },
        {
            header : 'Title',
            field : 'title',
            body : getTicketTitle,
            style: { minWidth: "350px"}
        },
        {
            header : 'Created By',
            field : 'createdBy',
            body : (row) => {
                let createdByName = row['createdUser.firstName']
                if(row['createdUser.lastName']){
                    createdByName = row['createdUser.firstName'] + " " + row['createdUser.lastName']
                }else{
                    createdByName = '-'
                }
                if(row.createdAt){
                    return <div>{createdByName}<br /> <span style={{ fontSize: '12px', color: 'gray' }}> {moment(new Date(row?.createdAt)).format(DATE_TIME_FORMAT)} </span></div>
                }
                else {
                    return <div>{createdByName}<br /> - </div>
                }
            },
            style: { minWidth: "200px"}
        },
        {
            header : 'Due Date',
            field : 'dueDate',
            body : getDueDate,
        },
        {
            header : 'Priority',
            field : 'priority',
            body: getPriority,
        },
        {
            header : 'Assigned To',
            field : 'assignedUser.firstName',
            body : (row) => {

                let assigneeName = row['assignedUser.firstName']
                if(row['assignedUser.lastName']){
                    assigneeName = assigneeName + " " + row['assignedUser.lastName']
                    return <div>{assigneeName}</div>
                }
                else {
                    return <div> - </div>
                }
            },
            style: { minWidth: "180px"}
        },
        {
            header : 'Category',
            field : 'category.categoryName',
            body : (row) => {
                return (
                    <div>
                        {row['category.categoryName']}
                        <br />
                        <span style={{ fontSize: '12px', color: 'gray' }}>
                            ({row['subCategory.subcategoryName']})
                        </span>
                    </div>
                )
            },
            style: { minWidth: "150px"}
        },
        {
            header: 'Status',
            field: 'status.statusName',
        }
    ]

    const handlePageChange = async (e) => {

        let paginatorParams = {
            paginator: true,
            pageNo: e.page + 1,
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            userId : userId,
            ...searchParams
        }
        if (searchParams.searchBy && searchParams.searchBy !== "all") {
            paginatorParams[searchParams.searchBy] = searchParams.searchText.trim();
        }
        dispatch(fetchTicketList(paginatorParams))
    }

    const handleSearchTabDisplay = () => {
        dispatch(setIsSearchVisible(!isSearchVisible))
    
    }

    const actionButtons = [
        {
          label: "Create Ticket",
          command: () => navigate(`/tickets/add`)
        },
        {
          icon: "pi pi-filter",
          label: "Filter",
          command: () => handleSearchTabDisplay(),
          className: isSearchActive ? "active-group-button" : ""
        },
    ]
    return (

        <div className="piwise-invoce-booking-layout flex flex-column">
            <Toast ref={Toast} />
            <div className="flex flex-column md:flex-row md:justify-content-between">
                <h4 className="mx-2 my-1 md:m-2">{activeUserRoleDetails?.companyId === PMCompanyDetails.companyId ? 'DRISHTI' : 'TICKET'}</h4> 
                <div className="flex gap-2 justify-content-end mb-2">
                    {/* <Button label="Create Ticket" onClick={() => navigate(`/tickets/add`)} className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300"></Button>
                    <div className="flex justify-content-end mb-2">
                        <Button icon="pi pi-filter" className={`h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${isSearchActive ? 'search-filter-active' : ''}`} label="Filter" onClick={handleSearchTabDisplay} />
                    </div> */}
                    <ButtonGroup buttons={actionButtons} />
                </div>
            </div>
            <div className='flex flex-row'>
                <div className="pi-wise-invoice-booking-table" style={{ order: "1", width: isSearchVisible  && !isMobileDevice  ? "82%" : "100%", maxHeight: "'calc(100%-100px)'" }}>
                    <div className='p-card mb-0'>
                        <div className="flex-grow-1">
                            <Table
                                lazy
                                page={paginationParams.pageNo - 1}
                                onPageChange={(e) => handlePageChange(e)}
                                tableColumns={tableColumns}
                                data={ticketList}
                                rows={paginationParams.recordsPerPage}
                                scrollable={"true"}
                                scrollHeight={"550px"}
                                paginator
                                totalRecords={paginationParams.totalRecords}
                                loading={isLoading}
                            />
                        </div>
                    </div>
                </div>

                {
                    isSearchVisible && !isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end ">
                        <TicketSearch />
                    </div>
                }

                {
                    isSearchVisible  && isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                        <Sidebar position='right' visible={isSearchVisible} onHide={() => dispatch(setIsSearchVisible(false))}>
                            <TicketSearch />
                        </Sidebar>
                    </div>
                }
            </div>
        </div>

    )
}

export default TicketList
